const AMOUNT_FIELDS = ['rent_amount', 'laundry_amount', 'parking_amount', 'cleaning_amount', 'other_amount'];

const readAmount = (value) => {
  if (value == null || value === '' || typeof value === 'boolean') return null;
  const amount = Number(value);
  return Number.isFinite(amount) ? amount : null;
};

export const getBillTotal = (bill) => {
  const lineItemsTotal = AMOUNT_FIELDS.reduce((total, field) => total + (readAmount(bill[field]) ?? 0), 0);
  const storedTotal = readAmount(bill.total_amount) ?? readAmount(bill.amount);
  // Some historical bills have a zero total despite populated charges.
  // Paid status clears the outstanding balance, not the original bill amount.
  if (storedTotal === 0 && lineItemsTotal > 0) return lineItemsTotal;
  return storedTotal ?? lineItemsTotal;
};

export const getUnpaidBills = (bills) => bills.filter((bill) => (
  bill.status === 'unpaid' && !Number(bill.laundry_is_subscription)
));

export const getUnpaidTotal = (bills) => getUnpaidBills(bills)
  .reduce((total, bill) => total + getBillTotal(bill), 0);
